import { useLocation } from '../../../contexts/RouterContext';

/**
 * Determines which Subnav item is active based on the current pathname.
 *
 * @param {string} baseProjectURL - The URL without the branch/revision part.
 * @param {string} baseRevisionURL - The URL with the branch/revision part.
 */
const useActiveKey = (
  baseProjectURL: string,
  baseRevisionURL: string,
) => {
  const { pathname } = useLocation();
  //  For most paths, there are path params for the branch + revision
  if (pathname.includes(baseRevisionURL)) {
    const [, activeKey] = pathname.split(baseRevisionURL);
    const maybeActiveKey = activeKey?.slice(1); // Slice to remove the leading "/"
    //  Preview is the public "logged out" view of the project.
    if (maybeActiveKey === 'preview') {
      return 'summary';
    }
    return maybeActiveKey || 'summary';
  }
  //  This handles paths where there is no branch + revision.
  const [, activeKey] = pathname.split(baseProjectURL);

  //  Handle all the settings sub-paths
  if (activeKey?.startsWith('/settings')) {
    return 'settings';
  }
  return activeKey?.slice(1) || 'summary'; // Slice to remove the leading "/"
};

export default useActiveKey;
